export const PRODUCT_VARIANT = 'ProductVariant';
/** Maximum number of OPTION-axis variation option slots per variant (business limit). */
export const PRODUCT_VARIANT_MAX_OPTIONS = 5;
//# sourceMappingURL=product-variant.js.map